import { Map, List, OrderedMap } from 'immutable';
import { toUpper } from 'lodash';
import { SERVICE_PER_PERSON_TYPES } from '../config/constants';

export const addServiceByTime = (blockIdx, service, reservationBlocks, date, addServiceByTime) => {

    let serviceBlock = OrderedMap();
    let serviceDates = List();

    let quantity = 1;
    let price = service.get('price');

    const block = reservationBlocks.find(block => block.get('idx') === blockIdx);
    const currentService = block.get('services', List()).find(serviceBlock => serviceBlock.get('service_id') === service.get('id'));
    
    if(service.get('max_per_room', false)) {
      if(currentService && currentService.get('quantity', 0) >= service.get('max_per_room')) {
        return;
      }
    }

    const serviceType = toUpper(service.get("type"));
    const isPerson = SERVICE_PER_PERSON_TYPES.includes(serviceType);
    const worksWithQuota = !!service.get("works_with_quota", false);
    const worksWithQuotaTime = !!service.get("works_with_quota_time", false);

    if(isPerson) {
      quantity = block.get('adults') + block.get('childs', 0);
    }

    if(worksWithQuota) {
      serviceDates = serviceDates.push(Map({
        "quantity": quantity,
        "day": date.format('YYYY-MM-DD'),
        "time": worksWithQuotaTime ? date.format('HH:mm:ss') : null
      }));

      let day = service.get('days').find(day => day.get('day') === date.format('YYYY-MM-DD'));
      price = day.get('price');

      if(isPerson) price *= quantity;
    }

    const blockBody = Map({
      service_id: service.get('id'),
      price: price,
      quantity: quantity,
      dates: serviceDates
    });

    serviceBlock = serviceBlock.set(
      blockIdx,
      blockBody
    );

    addServiceByTime(serviceBlock);

    return blockBody;
}